/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "кеча",
      "0": "бугун",
      "1": "эртага",
      "future": {
        "one": "{0} кундан сўнг",
        "other": "{0} кундан сўнг"
      },
      "past": {
        "one": "{0} кун олдин",
        "other": "{0} кун олдин"
      }
    },
    "day-narrow": {
      "-1": "кеча",
      "0": "бугун",
      "1": "эртага",
      "future": {
        "one": "{0} кундан сўнг",
        "other": "{0} кундан сўнг"
      },
      "past": {
        "one": "{0} кун олдин",
        "other": "{0} кун олдин"
      }
    },
    "day-short": {
      "-1": "кеча",
      "0": "бугун",
      "1": "эртага",
      "future": {
        "one": "{0} кундан сўнг",
        "other": "{0} кундан сўнг"
      },
      "past": {
        "one": "{0} кун олдин",
        "other": "{0} кун олдин"
      }
    },
    "hour": {
      "0": "this hour",
      "future": {
        "one": "{0} соатдан сўнг",
        "other": "{0} соатдан сўнг"
      },
      "past": {
        "one": "{0} соат олдин",
        "other": "{0} соат олдин"
      }
    },
    "hour-narrow": {
      "0": "this hour",
      "future": {
        "one": "{0} соатдан сўнг",
        "other": "{0} соатдан сўнг"
      },
      "past": {
        "one": "{0} соат олдин",
        "other": "{0} соат олдин"
      }
    },
    "hour-short": {
      "0": "this hour",
      "future": {
        "one": "{0} соатдан сўнг",
        "other": "{0} соатдан сўнг"
      },
      "past": {
        "one": "{0} соат олдин",
        "other": "{0} соат олдин"
      }
    },
    "minute": {
      "0": "this minute",
      "future": {
        "one": "{0} дақиқадан сўнг",
        "other": "{0} дақиқадан сўнг"
      },
      "past": {
        "one": "{0} дақиқа олдин",
        "other": "{0} дақиқа олдин"
      }
    },
    "minute-narrow": {
      "0": "this minute",
      "future": {
        "one": "{0} дақиқадан сўнг",
        "other": "{0} дақиқадан сўнг"
      },
      "past": {
        "one": "{0} дақиқа олдин",
        "other": "{0} дақиқа олдин"
      }
    },
    "minute-short": {
      "0": "this minute",
      "future": {
        "one": "{0} дақиқадан сўнг",
        "other": "{0} дақиқадан сўнг"
      },
      "past": {
        "one": "{0} дақиқа олдин",
        "other": "{0} дақиқа олдин"
      }
    },
    "month": {
      "-1": "ўтган ой",
      "0": "бу ой",
      "1": "кейинги ой",
      "future": {
        "one": "{0} ойдан сўнг",
        "other": "{0} ойдан сўнг"
      },
      "past": {
        "one": "{0} ой аввал",
        "other": "{0} ой аввал"
      }
    },
    "month-narrow": {
      "-1": "ўтган ой",
      "0": "бу ой",
      "1": "кейинги ой",
      "future": {
        "one": "{0} ойдан сўнг",
        "other": "{0} ойдан сўнг"
      },
      "past": {
        "one": "{0} ой аввал",
        "other": "{0} ой аввал"
      }
    },
    "month-short": {
      "-1": "ўтган ой",
      "0": "бу ой",
      "1": "кейинги ой",
      "future": {
        "one": "{0} ойдан сўнг",
        "other": "{0} ойдан сўнг"
      },
      "past": {
        "one": "{0} ой аввал",
        "other": "{0} ой аввал"
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "last quarter",
      "0": "this quarter",
      "1": "next quarter",
      "future": {
        "other": "+{0} Q"
      },
      "past": {
        "other": "-{0} Q"
      }
    },
    "quarter-narrow": {
      "-1": "last quarter",
      "0": "this quarter",
      "1": "next quarter",
      "future": {
        "other": "+{0} Q"
      },
      "past": {
        "other": "-{0} Q"
      }
    },
    "quarter-short": {
      "-1": "last quarter",
      "0": "this quarter",
      "1": "next quarter",
      "future": {
        "other": "+{0} Q"
      },
      "past": {
        "other": "-{0} Q"
      }
    },
    "second": {
      "0": "ҳозир",
      "future": {
        "one": "{0} сониядан сўнг",
        "other": "{0} сониядан сўнг"
      },
      "past": {
        "one": "{0} сония олдин",
        "other": "{0} сония олдин"
      }
    },
    "second-narrow": {
      "0": "ҳозир",
      "future": {
        "one": "{0} сониядан сўнг",
        "other": "{0} сониядан сўнг"
      },
      "past": {
        "one": "{0} сония олдин",
        "other": "{0} сония олдин"
      }
    },
    "second-short": {
      "0": "ҳозир",
      "future": {
        "one": "{0} сониядан сўнг",
        "other": "{0} сониядан сўнг"
      },
      "past": {
        "one": "{0} сония олдин",
        "other": "{0} сония олдин"
      }
    },
    "week": {
      "-1": "ўтган ҳафта",
      "0": "бу ҳафта",
      "1": "кейинги ҳафта",
      "future": {
        "one": "{0} ҳафтадан сўнг",
        "other": "{0} ҳафтадан сўнг"
      },
      "past": {
        "one": "{0} ҳафта олдин",
        "other": "{0} ҳафта олдин"
      }
    },
    "week-narrow": {
      "-1": "ўтган ҳафта",
      "0": "бу ҳафта",
      "1": "кейинги ҳафта",
      "future": {
        "one": "{0} ҳафтадан сўнг",
        "other": "{0} ҳафтадан сўнг"
      },
      "past": {
        "one": "{0} ҳафта олдин",
        "other": "{0} ҳафта олдин"
      }
    },
    "week-short": {
      "-1": "ўтган ҳафта",
      "0": "бу ҳафта",
      "1": "кейинги ҳафта",
      "future": {
        "one": "{0} ҳафтадан сўнг",
        "other": "{0} ҳафтадан сўнг"
      },
      "past": {
        "one": "{0} ҳафта олдин",
        "other": "{0} ҳафта олдин"
      }
    },
    "year": {
      "-1": "ўтган йил",
      "0": "бу йил",
      "1": "кейинги йил",
      "future": {
        "one": "{0} йилдан сўнг",
        "other": "{0} йилдан сўнг"
      },
      "past": {
        "one": "{0} йил аввал",
        "other": "{0} йил аввал"
      }
    },
    "year-narrow": {
      "-1": "ўтган йил",
      "0": "бу йил",
      "1": "кейинги йил",
      "future": {
        "one": "{0} йилдан сўнг",
        "other": "{0} йилдан сўнг"
      },
      "past": {
        "one": "{0} йил аввал",
        "other": "{0} йил аввал"
      }
    },
    "year-short": {
      "-1": "ўтган йил",
      "0": "бу йил",
      "1": "кейинги йил",
      "future": {
        "one": "{0} йилдан сўнг",
        "other": "{0} йилдан сўнг"
      },
      "past": {
        "one": "{0} йил аввал",
        "other": "{0} йил аввал"
      }
    }
  },
  "locale": "uz-Cyrl"
})
}
